import React from 'react';

const AccordionContext = React.createContext({
  onHeaderClick: () => {},
  expandedSections: {},
});

export default AccordionContext;